import React, { useReducer, useContext } from "react";
import { enterpriseMembersReducer as reducer } from "../reducers/enterpriseMembersReducer";
import { enterpriseMembersActions as actions } from "../actions/enterpriseMembersActions";

const initialValue = {
  enterpriseId: null,
  teamId: null,
  members: null,
  showCredits: false,
  currentMember: null,
};

const enterpriseMembersContext = React.createContext();

const EnterpriseMembersContext = ({ enterpriseId, teamId, children }) => {
  initialValue.enterpriseId = enterpriseId;
  initialValue.teamId = teamId;
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <enterpriseMembersContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </enterpriseMembersContext.Provider>
  );
};

export const useEnterpriseMembersContext = () =>
  React.useContext(enterpriseMembersContext);
export default EnterpriseMembersContext;
